import { OrganizationOptionProps } from './OrganizationOption';

export function organizationRenderInput({
  name,
  siret,
}: OrganizationOptionProps): string {
  return `${name} ${siret}`;
}
